import React from "react";
import Wrp from '../../hoc/Wrp/Wrp';
import HeaderTabs from '../../Components/UI/HeaderTabs';
import {isSet} from '../../Utils/CommonFunctions';
import http from '../../services/http';
import ProfileService from '../../services/ProfileService';

  // Check page configuration permission before executing button action
  const checkPageConfigurationPermission = async (btnActionComponent, props) => {
    // Check if pages_config_setup_id is available in button details
    const pagesConfigSetupId = btnActionComponent?.pages_config_setup_id;
    
    // If pages_config_setup_id is not available, allow to proceed
    if (!pagesConfigSetupId) {
      console.log('No pages_config_setup_id found, allowing access');
      return true;
    }

    try {
      const hasPermission = await ProfileService.checkPagesConfigurationPermission(pagesConfigSetupId);
      if (!hasPermission) {
        props.showWarningMessage("You don't have permission to access this page. Please contact your administrator.");
      }
      return hasPermission;
    } catch (error) {
      console.error('Error checking page configuration permission:', error);
      props.showWarningMessage("Unable to verify permissions at the moment. Please try again later.");
      return false;
    }
  };

  // Wrapper function to check permission before executing click handler
  const wrapClickHandlerWithPermissionCheck = (originalHandler, btnActionComponent, props) => {
    return async (e, ...args) => {
      // Immediate log to verify function is called
      
      // Persist the event FIRST before any async operations (fixes React synthetic event warning)
      let persistedEvent = e;
      if (e && typeof e.persist === 'function') {
        e.persist();
        persistedEvent = e;
      }
      
      // Prevent default action immediately
      if (persistedEvent && typeof persistedEvent.preventDefault === 'function') {
        persistedEvent.preventDefault();
      }
      
      try {
        console.log('Wrapper: Checking permission before executing handler');
        let hasPermission = false;
        try {
          hasPermission = await checkPageConfigurationPermission(btnActionComponent, props);
          console.log('Wrapper: Permission check completed, hasPermission:', hasPermission);
        } catch (permError) {
          console.error('Error in checkPageConfigurationPermission:', permError);
          hasPermission = false;
        }
        
        if (hasPermission) {
          // If permission is granted, execute the original handler
          console.log('Wrapper: Permission granted, executing original handler');
          if (typeof originalHandler === 'function') {
            try {
              const result = originalHandler(persistedEvent, ...args);
              // Handle both sync and async handlers
              if (result && typeof result.then === 'function') {
                return await result;
              }
              return result;
            } catch (handlerError) {
              console.error('Error executing original handler:', handlerError);
            }
          }
        } else {
          // If permission is denied, the warning message is already shown by checkPageConfigurationPermission
          console.log('Wrapper: Permission denied, blocking action');
          // Stop event propagation using persisted event
          if (persistedEvent && typeof persistedEvent.stopPropagation === 'function') {
            persistedEvent.stopPropagation();
          }
        }
      } catch (wrapperError) {
        console.error('Error in wrapClickHandlerWithPermissionCheck:', wrapperError);
        // If there's an error in the wrapper itself, still try to execute the original handler
        if (typeof originalHandler === 'function') {
          try {
            return originalHandler(persistedEvent, ...args);
          } catch (handlerError) {
            console.error('Error executing original handler after wrapper error:', handlerError);
          }
        }
      }
    };
  };

  export const actionButtonPlacement =(key)=>{
    const actionBtn = {
      1:'CREATE_CLONE',
      2:'EDIT',
      3:'VIEW_PAGE',
      4:'UTILITY_MENU',
      5:'EACH_RECORD',
      6:'MASS_ACTION',
      7:'LIST',
      8:"OTHERS"
    }
    return actionBtn[key];
  }

  export const resolveDefaultLayoutIdFromDetails = (layoutDetails) => {
    if (!layoutDetails || typeof layoutDetails !== 'object') {
      return undefined;
    }
    const entries = Object.entries(layoutDetails);
    if (!entries.length) {
      return undefined;
    }
    const standardEntry = entries.find(([, detail]) =>
      isSet(detail?.layout_name, '').toLowerCase() === 'standard'
    );
    if (standardEntry) {
      return standardEntry[0];
    }
    if (entries.length === 1) {
      return entries[0][0];
    }
    return entries[0][0];
  };

  export const getEffectiveLayoutParams = (props) => {
    if (props?.isPopupWindow === true && props?.windowDetails) {
      return props.windowDetails;
    }
    return props?.match?.params || {};
  };

  export const filterActionComponentsByLayout = (components, layoutId, defaultLayoutId) => {
    if (!layoutId || !Array.isArray(components)) {
      return components;
    }
    return components.filter((item) => {
      const actionComponent = isSet(item.action_component, item);
      const layoutIds = actionComponent.layout_ids;
      // Empty layout_ids = default layout only (aligned with backend)
      if (!Array.isArray(layoutIds) || layoutIds.length === 0) {
        if (!defaultLayoutId) {
          return false;
        }
        return layoutId === defaultLayoutId;
      }
      return layoutIds.some((layoutItem) => {
        const value = layoutItem?.value || layoutItem;
        return value === layoutId;
      });
    });
  }

  export const placeActionButtons = (actionComponents)=>{
   const isPropertyAvailable =  actionComponents.hasOwnProperty('toggleBackgroundProcessModel');
    if(!isPropertyAvailable){
      actionComponents.toggleBackgroundProcessModel = ()=>{console.log("toggleBackgroundProcessModel handler not found");
      };
    }
    
    let actionButtonList = {
    ['CREATE_CLONE']:[],
    ['EDIT']:[],
    ['VIEW_PAGE']:[],
    ['UTILITY_MENU']:[],
    ['EACH_RECORD']:[],
    ['MASS_ACTION']:[],
    ['LIST']:[],
    ['OTHERS']:[]
    };
    //http://localhost:3000/layouts/${windowName}/${windowId}/delete/${layoutId}/${dataId}
    
    const params = actionComponents.params;
    const defaultLayoutId = params?.defaultLayoutId
      || resolveDefaultLayoutIdFromDetails(actionComponents.layout_details);
    const components = (actionComponents.skipLayoutFilter===true)
      ? actionComponents.components
      : filterActionComponentsByLayout(actionComponents.components, params?.layoutId, defaultLayoutId);
    // const fieldGroups = actionComponents.fieldGroups;
    
    if(components!==null && Array.isArray(components)){
      components.map((item)=>{
        // const actionComponentsFilters = item.action_components_filter;
        const btnActionComponent = isSet(item.action_component,item);
                      // console.log("btnActionComponent==",btnActionComponent);

        // console.log(item);
        if(btnActionComponent.is_active===true && Array.isArray(btnActionComponent.placement)){
          const placementArr =  (isSet(btnActionComponent.placement,[]).length==0)?[{value:8}]:isSet(btnActionComponent.placement,[]);
          placementArr.map((btnPlace)=>{
            let url = btnActionComponent.url_expression;
            let target = (btnPlace.content_display===1)?'_blank':''
            url = url.replace('${windowName}', params.windowName);
            url = url.replace('${windowId}', params.windowId);
            url = url.replace('${layoutId}', params.layoutId);
            if(params.page!=='list' && params.formId!=='' && params.formId!==undefined){
              url = url.replace('${dataId}', params.formId);
            }

            let redirecturl =  isSet(btnActionComponent.redirect_url_expression,'');
            // redirecturl = redirecturl.replace('${windowName}', params.windowName);
            // redirecturl = redirecturl.replace('${windowId}', params.windowId);
            // redirecturl = redirecturl.replace('${layoutId}', params.layoutId);
            // if(params.formId!=='' && params.formId!==undefined){
            //   redirecturl = redirecturl.replace('${dataId}', params.formId);
            // }
            // console.log(url);
            let buttonClassName = 'dropdown-item';
            let styles = {};
            if(actionButtonPlacement(btnPlace.value)==='CREATE_CLONE' || actionButtonPlacement(btnPlace.value)==='EDIT'){
                buttonClassName = btnActionComponent.button_style? `btn ${btnActionComponent.button_style}_bg mr-1`:'btn secondary_bg mr-1';
              if(btnActionComponent.component_name.toLowerCase()==='get rates') {
                buttonClassName = btnActionComponent.button_style? `btn ${btnActionComponent.button_style}_bg mr-1`:'btn primary_bg mr-1';
              }
            }
            let eventHandler = {}
            if(btnActionComponent.component_name.toLowerCase()==='save' && actionComponents.saveHandler!==null){
              eventHandler = {
                clickHandler: actionComponents.saveHandler
              }
              buttonClassName = btnActionComponent.button_style ? `btn ${btnActionComponent.button_style}_bg mr-1`: 'btn primary_bg mr-1';
              url= "";
              target  = '';
            }
            if(btnActionComponent.component_name.toLowerCase()==='preview' && actionComponents.previewHandler!==null){
              // console.log("preview--------",btnPlace.value);
              eventHandler = {
                clickHandler: actionComponents.previewHandler
              }
              buttonClassName = 'dropdown-item';
              url= "";
              target  = '';
            }

            if((btnActionComponent.component_name.toLowerCase()==='download as pdf' || btnActionComponent.button_type===7) && actionComponents.previewHandler!==null){
              // console.log("preview--------",btnPlace.value);
              eventHandler = {
                //clickHandler:actionComponents.previewHandler.bind(this,btnActionComponent)
                //actionComponents.previewHandler
                clickHandler: (e)=>actionComponents.previewHandler(e,btnActionComponent)
              }
              buttonClassName = 'dropdown-item';
              url= "";
            }

            if((btnActionComponent.component_name.toLowerCase()==='download as csv' || btnActionComponent.button_type===8 )&& actionComponents.previewHandler!==null){
              eventHandler = {
                //clickHandler:actionComponents.downloadCSVHandler.bind(this,false,btnActionComponent)
                //actionComponents.downloadCSVHandler
                clickHandler: (e)=>actionComponents.downloadCSVHandler(e,false,btnActionComponent)
              }
              buttonClassName = 'dropdown-item';
              url= "";
              target  = '';
            }
            if(btnActionComponent.component_name.toLowerCase()==='delete'){
              eventHandler = {
                clickHandler: actionComponents.massDeleteHandler
              }
              buttonClassName = 'dropdown-item';
              url= "";
              target  = '';
            }
            if(btnActionComponent.component_name.toLowerCase()==='compare rates'){
              eventHandler = {
                clickHandler: actionComponents.massCompareRatesHandler
              }
              // buttonClassName = 'dropdown-item';
              url= "";
              target  = '';
            }

            if(btnActionComponent.component_name.toLowerCase()==='clone' && actionComponents.cloneHandler!==null){
              eventHandler = {
                clickHandler: actionComponents.cloneHandler
              }
              buttonClassName = 'dropdown-item';
              url= "";
              target  = '';
            }

            if(btnActionComponent.component_name.toLowerCase()==='change owner' && actionComponents.changeOwnerHandler!==null){
              // console.log("preview--------",btnPlace.value);
              eventHandler = {
                clickHandler: (ids)=>actionComponents.changeOwnerHandler(ids)
              }
              buttonClassName = 'dropdown-item dropdown-item';
              url= "";
              target  = '';
            }
            if(btnActionComponent.button_type===2 && actionComponents.getRatesHandler!==undefined){
              const getRatesHandler = (btnActionComponent.component_name.toLowerCase()==='get rates')?isSet(actionComponents.getRatesMyShipHandler,()=>{}):actionComponents.getRatesHandler;
              // const getRatesHandler = actionComponents.getRatesHandler;
              styles = {
                // background:'#ea4335',
                // color:'#fff'
              }

              eventHandler = {
                clickHandler: wrapClickHandlerWithPermissionCheck(getRatesHandler.bind(this,btnActionComponent), btnActionComponent, actionComponents)
              }
              // buttonClassName = 'btn primary_bg mr-1';
              url= "";
              target  = '';
            }

            if(btnActionComponent.button_type===16 && actionComponents.getRatesHandler!==undefined){
              const getRatesHandler = actionComponents.getRatesHandler;
              eventHandler = {
                clickHandler: getRatesHandler.bind(this,btnActionComponent)
              }
              // buttonClassName = 'btn ';
              url= "";
              target  = '';
            }

            if(btnActionComponent.button_type===6 && actionComponents.calculationHandler!==undefined){
              const calculationHandler = actionComponents.calculationHandler;
              eventHandler = {
                //clickHandler:calculationHandler.bind(this,btnActionComponent)
                clickHandler: e => actionComponents.calculationHandler(e,btnActionComponent)
              }
              // buttonClassName = 'btn ';
              url= "";
              target  = '';
            }

            //if(btnActionComponent.component_name.toLowerCase().startsWith('convert') && actionComponents.convertHandler!==undefined){
            if(btnActionComponent.button_type===1 && btnActionComponent.conversion_setup_id!=='' && actionComponents.convertHandler!==undefined){
              eventHandler = {
                //clickHandler:actionComponents.convertHandler
                clickHandler: e => actionComponents.convertHandler(e,btnActionComponent.conversion_setup_id)
              }
              buttonClassName = 'dropdown-item';
              url= "";
              target  = '';
            }

            if(btnActionComponent.button_type===3 && btnActionComponent.automation_setup_id!=='' && actionComponents.automationHandler!==undefined){
              eventHandler = {
                clickHandler: e => actionComponents.automationHandler(e,btnActionComponent)
              }
              buttonClassName = 'dropdown-item';
              url= "";
              target  = '';
            }

             if(btnActionComponent.button_type===4 && btnActionComponent.api_setup_id!=='' && actionComponents.apiHandler!==undefined){
              eventHandler = {
                clickHandler: e => actionComponents.apiHandler(e,btnActionComponent)
              }
              buttonClassName = 'dropdown-item';
              url= "";
              target  = '';
            }

            if(btnActionComponent.button_type===5 && btnActionComponent.step_setup_id!=='' && actionComponents.stepsHandler!==undefined){
              eventHandler = {
                // clickHandler: e => actionComponents.stepsHandler(e,btnActionComponent)
                clickHandler: e => (btnActionComponent.is_background_process)?  actionComponents.toggleBackgroundProcessModel(e, btnActionComponent) :actionComponents.stepsHandler(e,btnActionComponent)

              }
              buttonClassName = (params.page==='add' || params.page==='edit' || params.page==='clone')? btnActionComponent.button_style?`btn ${btnActionComponent.button_style}_bg mr-1`:'btn secondary_bg mr-1':'dropdown-item';
              url= "";
              target  = '';
            }
            if(btnActionComponent.button_type===11 && btnActionComponent.pages_config_setup_id!=='' && actionComponents.loadPagesConfigAction!==undefined){
              //
              
              // console.log("btnActionComponent==",btnActionComponent);
              // Check if this is MASS_ACTION placement (value 6)
              const isMassAction = actionButtonPlacement(btnPlace.value)==='MASS_ACTION';
              
              if(isMassAction && actionComponents.massPagesConfigHandler!==undefined){
                // Use mass handler for MASS_ACTION placement
                eventHandler = {
                  clickHandler: wrapClickHandlerWithPermissionCheck((e)=>actionComponents.massPagesConfigHandler(e,btnActionComponent), btnActionComponent, actionComponents)
                }
                buttonClassName = 'dropdown-item';
              } 
              else {
                // Use single-record handler for other placements (e.g., Detail View buttons)
                eventHandler = {
                  clickHandler: wrapClickHandlerWithPermissionCheck((e) => {
                    const { layoutId, windowId, formId: routeFormId } = params || {};

                    // Prefer record ids from DOM attributes (when present), otherwise fallback to route params.
                    let formId = routeFormId ?? null;
                    let record_id = routeFormId ?? null;

                    try {
                      const target = e?.target;
                      if (target?.hasAttribute?.('selectId')) {
                        formId = target.getAttribute('selectId');
                      } else if (target?.parentElement?.hasAttribute?.('selectId')) {
                        formId = target.parentElement.getAttribute('selectId');
                      }
                    } catch (err) {}

                    try {
                      const target = e?.target;
                      if (target?.hasAttribute?.('record_id')) {
                        record_id = target.getAttribute('record_id');
                      } else if (target?.parentElement?.hasAttribute?.('record_id')) {
                        record_id = target.parentElement.getAttribute('record_id');
                      }
                    } catch (err) {}

                    const effectiveRecordId = record_id ?? formId;
                    const val = formId
                      ? Array.isArray(formId)
                        ? formId
                        : [formId]
                      : actionComponents.selectedRows;

                    const obj = {
                      val,
                      layoutId,
                      windowId,
                      record_id: effectiveRecordId,
                      isPagesHyperLink: false
                    };

                    const finalParams = {
                      meta_table_id: effectiveRecordId,
                      layoutId,
                      windowId,
                      record_id: effectiveRecordId
                    };

                    return actionComponents.loadPagesConfigAction('ID', btnActionComponent.pages_config_setup_id, {
                      history: actionComponents?.history,
                      onload: false,
                      pType: 'DEFAULT',
                      action: btnActionComponent,
                      obj,
                      params: finalParams
                    });
                  }, btnActionComponent, actionComponents)
                };
                buttonClassName = 'dropdown-item';
              }
               url= ""
               target = '';
            }
            

            if(btnActionComponent.button_type===10 && btnActionComponent.hyper_Thread_Version_setup_id!=='' && actionComponents.ratingsHandler!==undefined){
              eventHandler = {
                // clickHandler: e => actionComponents.stepsHandler(e,btnActionComponent)
                clickHandler: e => actionComponents.ratingsHandler(e,btnActionComponent)

              }
              buttonClassName = (params.page==='add' || params.page==='edit' || params.page==='clone')?btnActionComponent.button_style?`btn ${btnActionComponent.button_style}_bg mr-1`:'btn secondary_bg mr-1':'dropdown-item';
              if((params.page==='add' || params.page==='edit' || params.page==='clone') && btnActionComponent.component_name.toLowerCase()==='get rates') {
                buttonClassName = btnActionComponent.button_style? `btn ${btnActionComponent.button_style}_bg mr-1`:'btn primary_bg mr-1';
              } 
              url= "";
              target  = '';
            }
            
            if((btnActionComponent.component_name.toLowerCase()==='activate' || btnActionComponent.component_name.toLowerCase()==='inactivate') && actionComponents.statusHandler!==null){
              // console.log("preview--------",btnPlace.value);
              //console.log('btnActionComponent.component_name==',btnActionComponent.component_name)
              let statusParam = 'active';
              if(btnActionComponent.component_name.toLowerCase()==='activate'){
                statusParam = 'active';
              }
              if(btnActionComponent.component_name.toLowerCase()==='inactivate'){
                statusParam = 'inactive';
              }
              eventHandler = {
                //clickHandler:(ids)=>actionComponents.statusHandler(ids,btnActionComponent.component_name.toLowerCase())
                clickHandler: (ids)=>actionComponents.statusHandler(ids,statusParam)
              }
              buttonClassName = 'dropdown-item dropdown-item';
              url= "";
              target  = '';
            }
            // if(params.page==='action'){
              // console.log('actionResponse...',btnActionComponent,url);
            // }
            url = url.replace('http://localhost:3000','');
            url = url.replace('http://${Base_url}',''); 
             
            
            redirecturl = redirecturl.replace('http://localhost:3000','');
            redirecturl = redirecturl.replace('http://${Base_url}',''); 
            actionButtonList[actionButtonPlacement(btnPlace.value)]
              .push({
                access_mode:isSet(item.access_mode,true),
                href:url,
                redirect_url_expression:redirecturl,
                ...eventHandler,
                data:item,
                style:styles,
                name:btnActionComponent.component_name,
                attributes:{
                  className:buttonClassName,
                  
                  target:target,//(btnPlace.content_display!==1)?'_blank':'_blank'
                }
              })
            
          })
         
        }
      });
    }
    return actionButtonList;
    
  }


  //CHECK THE WINDOW FIELD IS EXISTS IN ACTIVITY TYPE
  export const checkIsAutoNumberFieldIsExists = (fieldGroups,details=false)=>{
    let isExist = false;
    let updateJSON = {};
    fieldGroups.map((section)=>{
      section.data.map((field)=>{
        // const fieldLabel = field.label.blocks[0].text.toLowerCase();
        if(field.element==='AutoNumber'){
          isExist = true;
          updateJSON = {
            section_index: section.section_index,
            itemIndex:field.itemIndex,
            item:field
          }
        }
      })
    })
    if(details===false){
      return isExist;
    }else{
      return {
        isExist:isExist,
        ...updateJSON
        }
    }
   }

  //CHECK THE WINDOW FIELD IS EXISTS IN ACTIVITY TYPE
  export const checkIsActivityTypeFieldIsExists = (fieldGroups,details=false)=>{
    let isExist = false;
    let updateJSON = {};
    fieldGroups.map((section)=>{
      section.data.map((field)=>{
        if(isSet(field.label,null)===null){return false; }
        const fieldLabel = isSet(field.label,{}).blocks[0].text.toLowerCase();
        if(field.element==='PickList' && fieldLabel.indexOf('activity type')!==-1){
          isExist = true;
          updateJSON = {
            section_index: section.section_index,
            itemIndex:field.itemIndex,
            item:field
          }
        }
      })
    })
    if(details===false){
      return isExist;
    }else{
      return {
        isExist:isExist,
        ...updateJSON
        }
    }
   }
   
  
   //CHECK THE WINDOW IS ACTIVITY, IF YES ACTIVITY TYPE DISPLAT AS TAB IN FORM PAGE
  export const ActivityWindowTab = (props)=>{
    const params = (props.isMasterWindow===true && props.isMasterWindow!==undefined)?props.windowDetails:props.match.params;
    let activityField = checkIsActivityTypeFieldIsExists(props.fieldGroups,true);
    activityField = {
      ...activityField,
      item:{...activityField.item,modType:'ADDFORM'}
    }
    const headerTabs = [];
    const activityFieldOptions = (activityField.isExist===true)?activityField.item.options:[];
    // console.log(activityFieldOptions);
    activityFieldOptions.map((option,optionIndex)=>{
    const selectedClass = (activityField.item.selectedValue===option.id)?'active':'';
      if(option.id!==''){
        headerTabs.push({
          name:option.value,
          attributes:{
            "aria-selected":true,
            id:option.id,
            key:optionIndex,
            className:"nav-link show cursor-pointer "+selectedClass,
          },
          clickHandler:props.onChangeInputAction.bind(this,activityField,option.id,'PickList')
        })
      }
    })
    return(
        <Wrp>
           {(params.windowName==='Activities' && activityField.isExist===true)?
             <HeaderTabs 
             attributes= {{
               className:"nav nav-pills navcrm-primary nav-pills-no-bd fixed-2",
               role:"tablist"
             }}
             headerTabsList={headerTabs} />
          :''}
        </Wrp>
    )
   }



export const  checkFieldTypeForHeader = (content,header)=>{
    let fieldType = 'HyperLink';
    if(content.length>0){
      content[0].fieldGroups.map((section)=>{
        section.data.map((item)=>{
          if(item.id===header.table_descriptor_id){
            if(item.element === 'Barcode') {
              fieldType = 'Barcode';
            }else if(item.element==='Image' && item.is_avatar==true){
              fieldType = 'Image';
            }else if(item.element==='CheckBoxes') {
              fieldType = 'Others';
            }else{
              fieldType = 'HyperLink';
            }
          }
        })
      })
    }
    return fieldType;
  }  
  
  export const  updateUsedAndUnusedFields = (fieldGroups,layoutFieldsCount)=>{
    let updateUnUsedLayoutFieldsCnt = {...layoutFieldsCount['unUsed']};
    fieldGroups.map((sec)=>{
        // Skip subform sections from count calculation
        if(sec.type === 'subform'){
          return;
        }
        sec.data.map((item)=>{
          if(item.isUnused===true){
            Object.entries(layoutFieldsCount['unUsed']).map(([key, field]) => { 
              isSet(key.split(','),[]).map((keyItem)=>{
                if(keyItem.toLowerCase()===item.element.toLowerCase()){ 
                  //key.indexOf(item.element)!==-1){
                  updateUnUsedLayoutFieldsCnt={
                    ...updateUnUsedLayoutFieldsCnt,
                    [key]:(updateUnUsedLayoutFieldsCnt[key]>0)?updateUnUsedLayoutFieldsCnt[key]-1:updateUnUsedLayoutFieldsCnt[key]
                  }
                }
              })
              
            })
          }
        })
      })
    return updateUnUsedLayoutFieldsCnt;
  } 

  export const isUsedFieldsLimitReached = (fieldGroups,layoutFieldsCount,fieldType)=>{
    let isLimitReached = false;
    let isContinue = true;
    let updateUnUsedLayoutFieldsCnt = {...layoutFieldsCount['used']};
    fieldGroups.map((sec)=>{
        sec.data.map((item)=>{
            if(item.element===fieldType && isContinue===true){
            Object.entries(layoutFieldsCount['used']).map(([key, field]) => { 
              isSet(key.split(','),[]).map((keyItem)=>{
                if(keyItem.toLowerCase()===item.element.toLowerCase()){
                  isLimitReached = (updateUnUsedLayoutFieldsCnt[key]===0)?true:false;
                  isContinue = false;
                }
              })
            })
          }
        })
      });
      if(isContinue===true){
        Object.entries(layoutFieldsCount['used']).map(([key, field]) => { 
          isSet(key.split(','),[]).map((keyItem)=>{
            if(keyItem.toLowerCase()===fieldType.toLowerCase()){
              isLimitReached = (updateUnUsedLayoutFieldsCnt[key]===0)?true:false;
              isContinue = false;
            }
          })
          // if(key.indexOf(fieldType)!==-1){
          //   isLimitReached = (updateUnUsedLayoutFieldsCnt[key]===0)?true:false;
          //   isContinue = false;
          // }
        }) 
      }
    return isLimitReached;
  }

    

export const  getFieldPropertiesFromGridList = (gridList,tableDescId)=>{
  let returnGrid = {};
  // console.log('gridList',gridList,tableDescId);
  gridList.map((grid)=>{
    if(grid.table_descriptor_id===tableDescId){
      returnGrid = grid;
    }
  });
  return returnGrid;
} 

export const variableDetailsLookupFromList = (arr, findingId) => {
  let returnData = {};
  // console.log('returnData findingId',arr,findingId);
  for (let i of isSet(arr, [])) {
    if (i.id === findingId || isSet(i.field_id_path, '') === findingId) {
      returnData = i;
      break; // Exit the loop early
    }
    if (isSet(i.fields, []).length > 0) {
      const nested = variableDetailsLookupFromList(isSet(i.fields, []), findingId);
      if (isSet(nested.id, null) !== null) {
        returnData = nested;
        break;
      }
    }
  }
  return returnData;
};